"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ButtonTs = _interopRequireDefault(require("@lt/components/components/ButtonTs"));

var _constants = require("../../constants");

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Group = function Group(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var data = props.data,
      _props$selectProps = props.selectProps,
      changeOptions = _props$selectProps.changeOptions,
      isMobile = _props$selectProps.isMobile;
  var customData = data;
  var groupName = customData.groupName,
      fullOptionsCount = customData.fullOptionsCount;
  if (!_constants.groupParams[groupName]) return null;
  var _groupParams$groupNam = _constants.groupParams[groupName],
      label = _groupParams$groupNam.label,
      showMoreTitle = _groupParams$groupNam.showMoreTitle;
  var groupIds = isMobile ? [groupName] : _constants.defaultExtendedGroupIds;
  var shownOptionsCount = fullOptionsCount ? fullOptionsCount - _constants.START_OPTIONS_COUNT : 0;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Group, _extends({
    className: "".concat(_constants.destinationPickerName, "__").concat(groupName)
  }, props, {
    label: label
  }), children), showMoreTitle && changeOptions && shownOptionsCount > 0 ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
    onClick: function onClick() {
      return changeOptions(groupIds);
    }
  }, showMoreTitle(shownOptionsCount)) : null);
};

exports.Group = Group;
var StyledButton = (0, _styledComponents["default"])(_ButtonTs["default"]).withConfig({
  displayName: "Group__StyledButton",
  componentId: "sc-1aj17re-0"
})(["&&{border:none;background:none;width:auto;padding:0 0 8px 8px;height:auto;font-size:12px;color:var(--secondary-header);}"]);